import script from "./SoTayChiTieuNhanVien.vue?vue&type=script&setup=true&lang=js"
export * from "./SoTayChiTieuNhanVien.vue?vue&type=script&setup=true&lang=js"

import "./SoTayChiTieuNhanVien.vue?vue&type=style&index=0&id=8d97544e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d97544e"]])

export default __exports__